var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSort = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13 .5a1 1 0 0 1 1 1v12.458h2.464L13 17.5l-3.464-3.542H12V1.5a1 1 0 0 1 1-1Zm-8 17a1 1 0 0 0 1-1V4.042h2.464L5 .5 1.536 4.042H4V16.5a1 1 0 0 0 1 1Z",
  clipRule: "evenodd"
})));
export default SvgIconSort;